// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__AuthenticationPage__root","card":"cms__AuthenticationPage__card","errorMsg":"cms__AuthenticationPage__errorMsg","message":"cms__AuthenticationPage__message","button":"cms__AuthenticationPage__button"};


//////////////////
// WEBPACK FOOTER
// ./backends/netlify-auth/AuthenticationPage.css
// module id = 258
// module chunks = 0